/**
 * FreeSpinsOutroView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsOutro extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      this._fromNumFreeSpinsText = undefined;
      this._winningsText = undefined;
      this._panel = undefined;
      this._darkOverlay = undefined;
      this._pressStartBox = undefined;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._fromNumFreeSpinsText = resourceManager.get(
        'freeSpinsOutroContainer:FreeSpinsOutro:panel:fromNumFreeSpinsText'
      );
      this._bonusCompleteText = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:panel:bonusCompleteText');
      this._congratsText = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:panel:congratsText');
      this._winningsText = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:panel:winningsText');
      this._panel = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:panel');
      this._darkOverlay = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:darkOverlay');
      this._pressStartBox = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:pressStartColourBox');

      this._darkOverlay.interactive = true; // stop being able to click on anything behind the panel
      this._pressStartBox.interactive = false;
    }

    async show(numFS, winAmount, showCongrats) {
      if (showCongrats === true) {
        this._bonusCompleteText.renderable = false;
        this._congratsText.renderable = true;
      } else {
        this._bonusCompleteText.renderable = true;
        this._congratsText.renderable = false;
      }

      this._fromNumFreeSpinsText.setTranslationParameters(numFS);
      this._winningsText.setText(gdk.formatCurrency(winAmount));
      this.visible = true;
      this._pressStartBox.interactive = false;

      soundManager.play('panelAppear');

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          duration: 0.5,
          ease: 'bounce.out',
        }
      );

      let waitForInteractionResolver = null;
      const waitForInteractionPromise = new Promise((resolve) => {
        waitForInteractionResolver = resolve;
      });

      const pressedCB = () => {
        game.stopAutoClickForReplayRewatch();
        if (this._pressStartBox.interactive === true) {
          this._pressStartBox.interactive = false;
          waitForInteractionResolver();
        }
      };
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = pressedCB;

      this._pressStartBox.interactive = true;
      game.autoClickForReplayRewatch(pressedCB);
      await waitForInteractionPromise;

      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      soundManager.play('panelRemove');

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0,
          y: 0,
          duration: 0.15,
          ease: 'none',
        }
      );

      this.visible = false;
    }
  }

  let create = function (json) {
    return new FreeSpinsOutro();
  };

  let initialise = function (json, container, resources) {
    container.initialise();
  };

  let getFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('FreeSpinsOutro', create, initialise, getFilesRequired);
})();
